import { useLayoutEffect } from 'react';
import { useTheme } from '@material-ui/core/styles';
import { useFeelPanelBranding } from './FeelPanelBrandingContext';

function accentToCssHex(accent) {
  if (accent == null || String(accent).trim() === '') {
    return null;
  }
  const raw = String(accent)
    .trim()
    .replace(/^#/, '');
  if (/^[0-9a-fA-F]{6}$/.test(raw)) {
    return `#${raw.toLowerCase()}`;
  }
  if (/^[0-9a-fA-F]{3}$/.test(raw)) {
    const [r, g, b] = raw.split('');
    return `#${r}${r}${g}${g}${b}${b}`.toLowerCase();
  }
  return String(accent)
    .trim()
    .startsWith('#')
    ? String(accent).trim()
    : `#${raw}`;
}

const DEFAULT_PRIMARY_RGB = '230, 97, 106';

function primaryColorToRgbComma(input) {
  if (input == null || String(input).trim() === '') {
    return DEFAULT_PRIMARY_RGB;
  }
  const s = String(input).trim();
  const m6 = s.match(/^#?([0-9a-fA-F]{6})$/i);
  if (m6) {
    const h = m6[1];
    return `${parseInt(h.slice(0, 2), 16)}, ${parseInt(h.slice(2, 4), 16)}, ${parseInt(h.slice(4, 6), 16)}`;
  }
  const m3 = s.match(/^#?([0-9a-fA-F]{3})$/i);
  if (m3) {
    const [r, g, b] = m3[1].split('');
    return `${parseInt(r + r, 16)}, ${parseInt(g + g, 16)}, ${parseInt(b + b, 16)}`;
  }
  const rgb = s.match(/rgba?\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)/);
  if (rgb) {
    return `${rgb[1]}, ${rgb[2]}, ${rgb[3]}`;
  }
  return DEFAULT_PRIMARY_RGB;
}

function FeelPrimaryPaletteSync() {
  const theme = useTheme();
  const { resolvedPanelBranding } = useFeelPanelBranding();
  const brandingHex = accentToCssHex(resolvedPanelBranding?.accentColor);

  useLayoutEffect(() => {
    const { main, dark, light } = theme.palette.primary;
    if (brandingHex) {
      document.documentElement.style.setProperty('--feel-primary', brandingHex);
      document.documentElement.style.setProperty('--feel-primary-dark', dark);
      document.documentElement.style.setProperty('--feel-primary-light', light);
      document.documentElement.style.setProperty('--feel-primary-rgb', primaryColorToRgbComma(brandingHex));
      return;
    }
    const mainStr = typeof main === 'string' ? main : String(main);
    document.documentElement.style.setProperty('--feel-primary', mainStr);
    document.documentElement.style.setProperty('--feel-primary-dark', dark);
    document.documentElement.style.setProperty('--feel-primary-light', light);
    document.documentElement.style.setProperty('--feel-primary-rgb', primaryColorToRgbComma(mainStr));
  }, [brandingHex, theme.palette.primary]);

  return null;
}

export default FeelPrimaryPaletteSync;
